const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/meals/index.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/meals/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { listSavedMealsQuery } from '@/features/saved-meals/lib/list-saved-meals.query';
export const Route = createFileRoute('/_authenticated/resources/meals/')({
  loader: async ({
    context,
    location
  }) => {
    try {
      await context.queryClient.ensureInfiniteQueryData(listSavedMealsQuery({
        controllers: {
          savedMealController: context.deps.controllers.savedMealController
        }
      }, ''));
    } catch (error) {
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});